import React, { Fragment, useState } from 'react'
import { Menu } from '@mui/icons-material'
import { toast } from 'react-toastify'
import { BASE_URL_API_DE_NEW, } from '../../constants'
import { useAuth } from '../../contexts/AuthContext'
import Button from '../Button'
import Modal from '../Modal'
import { FetchApi } from '../../api/fetch'

type Props = {
   data: any;
   getCommunity: () => void
   initiateEdit: () => void
}

export function CommunityCard({ data, getCommunity, initiateEdit }: Props) {
   const [deleteInitiated, setDeleteInitiated] = useState<boolean>()
   const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()

   const handleClose = () => {
      setDeleteInitiated(false)
   }
   const onDelete = () => {
      setDeleteInitiated(true)
   }

   const deleteFeatured = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()
      try {
         let response: any = await FetchApi({
            endpoint:`${BASE_URL_API_DE_NEW}v2/user/delete-whitelist-partner/${data?.id}`,
            method: "DELETE",
            JWT:userJWT
         })

         if (response) {
            getCommunity();
         }
         if (!response.success) {
            toast.error(response.message)
         }
         setIsLoadingOverlayDisplay(false)

      } catch (error) {
         console.log('something went wrong');
      }
   }

   const exportPartnerData = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()

      try {
         const stats = await FetchApi({
            endpoint:`${BASE_URL_API_DE_NEW}v2/user/export-partner-data/${data?.collectionId}`, 
            method: "GET",
            JWT:userJWT,
            format:'blob'
         })


         var file = window.URL.createObjectURL(stats);
         window.location.assign(file);
      } catch (error) {
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)
   }
   return (
      <Fragment>

         <div className="bg-gray-80 flex items-center justify-between p-4 my-4 rounded-xl">
            <div className='flex items-center'>
               <div>
                  <Menu className="h-8 text-gray-50 mr-3" />
               </div>
               <div className="feat-desc flex items-center">
                  <div className=" min-w-20">
                     <img src={data.image} className="rounded-full w-16 h-16" alt='patner' />
                  </div>
                  <div className='w-10/12'>
                     <h3 className="mb-1 font-medium">{data?.collectionName || data?.tokenName}</h3>
                     <p className="font-extralight text-sm">{data?.numberOfSpots - data?.totalAllocations} / {data?.numberOfSpots} spots</p>
                  </div>
               </div>
            </div>

            <div className="flex">
               <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center mr-3 text-sm" onClick={initiateEdit}>
                  Edit
               </button>
               <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center mr-3 text-sm" onClick={exportPartnerData}>
                  Export
               </button>
               <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center mr-3 text-sm" onClick={onDelete}>
                  Delete
               </button>
            </div>
         </div>

         <Modal show={deleteInitiated} hide={handleClose} sub='Are you sure you want to delete whitelist partner'>
            <div className='flex justify-center gap-3 mt-8'>
               <div className=" text-center">
                  <button onClick={handleClose} className="block bg-gradient rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 text-md text-semibold">
                     <span
                        className="w-36 bg-gray-90 block m-0.5 rounded-lg py-3"
                     >
                        No
                     </span>
                  </button>
               </div>
               <Button
                  type="button"
                  className="mb-0 sm:mb-2 w-36 btn bg-gradient text-kyzzen-primary rounded-lg font-medium "
                  onClick={deleteFeatured}
               >
                  Yes
               </Button>
            </div>
         </Modal>

      </Fragment>
   )
}


export function TokenCommunityCard({ data, getCommunity, initiateEdit }: Props) {
   const [deleteInitiated, setDeleteInitiated] = useState<boolean>()
   const { getUserJWT, setIsLoadingOverlayDisplay } = useAuth()

   const handleClose = () => {
      setDeleteInitiated(false)
   }
   const onDelete = () => {
      setDeleteInitiated(true)
   }

   const deleteFeatured = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = await getUserJWT()
      try {
         let response: any = await fetch(`${BASE_URL_API_DE_NEW}v2/user/delete-token-whitelist-partner/${data?.id}`, {
            method: "DELETE",
            headers: {
               "Content-type": "application/json",
               Authorization: userJWT ? `Bearer ${userJWT}` : "",
            },
         })
         response = await response.json()

         if (response) {
            getCommunity();
         }
         if (!response.success) {
            toast.error(response.message)
         }
         setIsLoadingOverlayDisplay(false)

      } catch (error) {
         console.log('something went wrong');
      }
   }

   const exportPartnerData = async () => {
      setIsLoadingOverlayDisplay(true)
      const userJWT = getUserJWT()

      try {
         const res = await fetch(`${BASE_URL_API_DE_NEW}v2/user/export-token-partner-data/${data?.tokenId}`, {
            method: "GET",
            headers: {
               "Content-type": "application/json",
               Authorization: userJWT ? `Bearer ${userJWT}` : "",
            },
         })

         const stats = await res.blob()

         var file = window.URL.createObjectURL(stats);
         window.location.assign(file);
      } catch (error) {
         // :TODO
         // add error toast
         console.log(error);

      }
      setIsLoadingOverlayDisplay(false)
   }
   return (
      <Fragment>

         <div className="bg-gray-80 flex items-center justify-between p-4 my-4 rounded-xl">
            <div className='flex items-center'>
               <div>
                  <Menu className="h-8 text-gray-50 mr-3" />
               </div>
               <div className="feat-desc flex items-center">
                  <div className=" min-w-20">
                     <img src={data.image} className="rounded-full w-16 h-16" alt='patner' />
                  </div>
                  <div className='w-10/12'>
                     <h3 className="mb-1 font-medium">{ data?.tokenName}</h3>
                     <p className="font-extralight text-sm">{data?.numberOfSpots - data?.totalAllocations} / {data?.numberOfSpots} spots</p>
                     {/* <p className="font-extralight text-sm">{data?.minAmountToQualify} {data?.tokenSymbol} required</p> */}
                  </div>
               </div>
            </div>

            <div className="flex">
               <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center mr-3 text-sm" onClick={initiateEdit}>
                  Edit
               </button>
               <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center mr-3 text-sm" onClick={exportPartnerData}>
                  Export
               </button>
               <button className="border border-gray-50 text-gray-50 py-1.5 px-3 rounded-xl flex items-center mr-3 text-sm" onClick={onDelete}>
                  Delete
               </button>
            </div>
         </div>

         <Modal show={deleteInitiated} hide={handleClose} sub='Are you sure you want to delete whitelist partner'>
            <div className='flex justify-center gap-3 mt-8'>
               <div className=" text-center">
                  <button onClick={handleClose} className="block bg-gradient rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 text-md text-semibold">
                     <span
                        className="w-36 bg-gray-90 block m-0.5 rounded-lg py-3"
                     >
                        No
                     </span>
                  </button>
               </div>
               <Button
                  type="button"
                  className="mb-0 sm:mb-2 w-36 btn bg-gradient text-kyzzen-primary rounded-lg font-medium "
                  onClick={deleteFeatured}
               >
                  Yes
               </Button>
            </div>
         </Modal>
      </Fragment>
   )
}